module.exports = function getResource(label, vars = []) {
    let resources = {
        post: 'post',
        posts: 'posts',
        group: 'group',
        groups: 'groups',
        photo: 'photo',
        photos: 'photos',
        review: 'review',
        reviews: 'reviews'
    };
    return resources[label];
};
